import { useState } from "react";

interface ShareButtonsProps {
  title: string;
}

export default function ShareButtons({ title }: ShareButtonsProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  const targets = [
    { label: "微博", icon: "ri-weibo-fill", url: `https://service.weibo.com/share/share.php?title=${encodeURIComponent(title)}&url=${encodeURIComponent(typeof window !== "undefined" ? window.location.href : "")}` },
    { label: "豆瓣", icon: "ri-douban-fill", url: "https://www.douban.com/" },
    { label: "微信", icon: "ri-wechat-fill", url: "" },
  ];

  return (
    <div className="flex flex-wrap items-center gap-2">
      <button
        type="button"
        onClick={handleCopy}
        className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
      >
        <span className="flex h-4 w-4 items-center justify-center">
          <i className={copied ? "ri-check-line text-accent-600" : "ri-link"}></i>
        </span>
        {copied ? "已复制链接" : "复制链接"}
      </button>
      {targets.map((t) =>
        t.url ? (
          <a
            key={t.label}
            href={t.url}
            target="_blank"
            rel="noreferrer"
            title={`分享到${t.label}`}
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className={t.icon}></i>
            </span>
            {t.label}
          </a>
        ) : (
          <button
            key={t.label}
            type="button"
            onClick={handleCopy}
            title={`分享到${t.label}`}
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className={t.icon}></i>
            </span>
            {t.label}
          </button>
        ),
      )}
    </div>
  );
}